<template>
    <div>
        <v-app-bar absolute outlined flat color="background" app>
            <div class="d-flex align-center">
                <v-app-bar-nav-icon
                    v-if="!drawer"
                    @click.stop="$emit('update-drawer')"
                ></v-app-bar-nav-icon>
            </div>

            <v-spacer></v-spacer>

            <userMenu />
        </v-app-bar>
    </div>
</template>

<script>
import userMenu from './user-menu'

export default {
    name: 'navbar',
    props: ['drawer'],
    components: { userMenu },
}
</script>
